export const contact = {
  name: 'Motor City Truck Collision',
  phoneDisplay: '248-986-8000',
  phoneHref: 'tel:+12489868000',
  street: '12264 Emerson Dr.',
  cityLine: 'Brighton, MI 48116',
};

export const urls = {
  quote: '/request-a-quote.html',
  home: '/',
  services: '/10.html',
  trailerOverview: '/26.html',
  about: '/34.html',
  resources: '/repair-guides',
  collision: '/Semi-Truck-Body-Shop',
  rv: '/RV-Repair',
  trailer: '/Trailer-Repair',
  liftgate: '/Lift-Gate-Repair',
  serviceBody: '/Service-Body-Repair',
  wraps: '/CommercialVehicleGraphicWraps.html',
  blasting: '/dustless-sandblasting.html',
  payment: '/18.html',
  careers: '/Body-Shop-Jobs',
  semi: '/Semi-Truck-Body-Shop',
  boxTruck: '/box-truck-repair.html',
  paint: '/Commercial-Truck-Paint-Shop',
  fleet: '/Fleet-Truck-Body-Repair',
  gallery: '/ourrepairwork.html',
  contact: '/contact-motor-city-truck-collision.html',
  heavyEquipment: '/earthmoving-equipment-restoration-paint-repair.html',
  privacy: '/privacy-policy',
  garrett: 'https://www.garrettauto.com/',
  directions:
    'https://www.google.com/maps/search/?api=1&query=12264%20Emerson%20Dr.%2C%20Brighton%2C%20MI%2048116',
};

export const images = {
  logo: 'https://drwzpk38qkpfb.cloudfront.net/www.motorcitytruckcollision.com/uploaded/images/header/widestroke2.png',
  hero: 'https://cdn.magicpatterns.com/uploads/daqjtkibJsXhv49pyTCsSc/hero-semi-cul-de-sac-ai-v2.webp',
  boxTruck: 'https://www.motorcitytruckcollision.com/uploaded/images/Collision/Box-Truck-Repair/box-truck-repairs-418.jpg',
  hood: 'https://www.motorcitytruckcollision.com/uploaded/images/moto_city_gallery/10_IMG_0033_2.jpg',
  cab: 'https://www.motorcitytruckcollision.com/uploaded/images/moto_city_gallery/11_IMG_0100.jpg',
  workTruck: 'https://www.motorcitytruckcollision.com/uploaded/images/moto_city_gallery/12_IMG_0184.jpg',
  garrettLogo: 'https://drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/NewDesign/logo_black_bg.jpg',
  paintBooth: 'https://www.motorcitytruckcollision.com/uploaded/images/special_projects.png',
};
